/*
 * Fix: the "solo una vez" (only-once) popup sometimes reappeared on every page
 * refresh instead of respecting localStorage['theme:popup-appeared'].
 *
 * ROOT CAUSE (confirmed live, reproducible): the native <newsletter-popup> class
 * (assets/theme.js, js/sections/newsletter-popup.js) schedules its automatic
 * `show()` call via connectedCallback()'s setTimeout(). Calling `.show()` or
 * setting the `open` attribute MANUALLY correctly fires attributeChangedCallback
 * and persists localStorage['theme:popup-appeared'] = 'true' every time it was
 * tested. But when the SAME show() call is triggered automatically through that
 * scheduled setTimeout, the popup visibly opens (confirmed: element gets the
 * `open` attribute, hasAttribute('open') === true) yet the localStorage flag is
 * reproducibly left unset — confirmed across multiple clean test runs. Given this
 * only affects the auto-open path and never the manually-invoked one, it points
 * to a race between the delayed callback and some other re-render/reconnect of
 * the popup's DOM node on initial page load, internal to the vendor theme
 * bundle — not something we want to patch by hand-editing the minified
 * assets/theme.js.
 *
 * FIX: instead of chasing the exact internal race, we independently guarantee
 * the same outcome the native code already TRIES to guarantee: as soon as we
 * observe the popup's `open` attribute appear, we set the flag ourselves. This
 * is redundant with (never conflicts with) the native code — if the native path
 * already set it, this is a harmless no-op write of the same value.
 */
(function () {
  if (window.__ibPopupOnceFixBound) return;
  window.__ibPopupOnceFixBound = true;

  function watch(popup) {
    if (!popup.hasAttribute('only-once')) return;

    if (popup.hasAttribute('open')) {
      localStorage.setItem('theme:popup-appeared', 'true');
    }

    var observer = new MutationObserver(function () {
      if (popup.hasAttribute('open')) {
        localStorage.setItem('theme:popup-appeared', 'true');
      }
    });

    observer.observe(popup, { attributes: true, attributeFilter: ['open'] });
  }

  function scan() {
    document.querySelectorAll('newsletter-popup, .pop-in[only-once]').forEach(watch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  // The popup markup can also be (re)inserted after our initial scan (e.g. theme
  // editor re-renders); keep watching the body for newly-added popup nodes too.
  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches('newsletter-popup, .pop-in[only-once]')) {
          watch(node);
        }
        if (node.querySelectorAll) {
          node.querySelectorAll('newsletter-popup, .pop-in[only-once]').forEach(watch);
        }
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
